export const ADD_NEW_CHAT_MESSAGE_FAILURE = 'ADD_NEW_CHAT_MESSAGE_FAILURE';

export const addNewChatMessageFailure = error => ({
    type: ADD_NEW_CHAT_MESSAGE_FAILURE,
    payload: error,
    error: true,
});
